import styled from '@emotion/styled'

import media from '../../../styles/media'

const S = {}

S.Social = styled.ul`
  list-style-type: none;
  padding-left: 0;
  padding-right: 0;
  text-align: center;
  margin-top: 1.625rem;
  margin-bottom: 2.25rem;
  display: flex;
  justify-content: center;

  .social-item {
    display: inline-block;

    html:not([dir]) &,
    [dir='ltr'] & {
      margin-right: 1.5rem;

      &:last-child {
        margin-right: 0;
      }
    }

    [dir='rtl'] & {
      margin-left: 1.5rem;

      &:last-child {
        margin-left: 0;
      }
    }
  }

  .social-link {
    display: flex;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;

    ${media.xs`
      width: 3rem;
      height: 3rem;
    `};
  }

  .social-icon {
    width: auto;
    height: 1.375rem;

    ${media.xs`
      height: 1.625rem;
    `};

    &.instagram,
    &.linkedin {
      height: 1.5rem;

      ${media.xs`
        height: 1.75rem;
      `};
    }

    &.linkedin {
      ${media.xs`
        transform: translateX(0.0625rem);
      `};
    }

    &.vk {
      height: 2.25rem;

      ${media.xs`
        height: 3rem;
      `};
    }
  }
`

export default S
